var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _vm.lastOperation
        ? _c(
            "v-flex",
            [
              _vm.operationInProgress
                ? _c("v-progress-circular", {
                    attrs: {
                      size: 20,
                      width: 2,
                      color: "green",
                      indeterminate: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.lastOperationSuccess
                ? _c("v-icon", { attrs: { color: "success" } }, [
                    _vm._v("fas fa-check-circle"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.lastOperationFailure
                ? _c("v-icon", { attrs: { color: "error" } }, [
                    _vm._v("fas fa-ban"),
                  ])
                : _vm._e(),
              _vm._v(
                "\n     " +
                  _vm._s(_vm.lastOperation) +
                  "\n     (at " +
                  _vm._s(_vm.lastOperationDateTime) +
                  ")\n  "
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-flex", [
        _vm._v("\n    " + _vm._s(_vm.lastOperationMessage) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }